module.exports = __webpack_public_path__ + "img/totalPending.fe3c4889.svg";